export enum FedexSignatureEnum {
  NONE = "NONE",
  NO_SIGNATURE_REQUIRED = "NO_SIGNATURE_REQUIRED",
  INDIRECT_SIGNATURE = "INDIRECT_SIGNATURE",
  DIRECT_SIGNATURE = "DIRECT_SIGNATURE",
  ADULT_SIGNATURE = "ADULT_SIGNATURE",
}
